import React, { useEffect, useState } from "react";
import { API_programas, API_ciudadanos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaRegTrashCan } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";
import { useAuth } from "../../context/AuthContext";

const Programas = ({ usuario }) => {
  const { token } = useAuth();
  const [programasDisponibles, setProgramasDisponibles] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [selectedPrograma, setSelectedPrograma] = useState("");

  useEffect(() => {
    const fetchProgramas = async () => {
      const res = await fetch(API_programas);
      const data = await res.json();
      setProgramasDisponibles(data);
    };
    fetchProgramas();
  }, []);

  useEffect(() => {
    if (
      usuario?.programasInscritos &&
      Array.isArray(usuario.programasInscritos) &&
      programasDisponibles.length > 0
    ) {
      const normalizar = (str) =>
        str
          ?.normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim();

      const inscritosConFechas = usuario.programasInscritos
        .map((nombrePrograma) => {
          const infoCompleta = programasDisponibles.find(
            (p) => normalizar(p.nombre) === normalizar(nombrePrograma)
          );
          return infoCompleta
            ? {
                nombre: infoCompleta.nombre,
                fechaInicio: infoCompleta.fechaInicio,
                fechaFin: infoCompleta.fechaFin,
              }
            : null;
        })
        .filter(Boolean);

      setProgramas(inscritosConFechas);
    }
  }, [usuario, programasDisponibles]);

  /* Añadir programa */
  const handleAddPrograma = async () => {
    const infoCompleta = programasDisponibles.find(
      (p) => p.nombre === selectedPrograma
    );

    if (infoCompleta) {
      const nuevosProgramas = [
        ...programas,
        {
          nombre: infoCompleta.nombre,
          fechaInicio: infoCompleta.fechaInicio,
          fechaFin: infoCompleta.fechaFin,
        },
      ];

      setProgramas(nuevosProgramas);
      setSelectedPrograma("");

      // Hacer PUT a la API con solo los nombres
      try {
        const body = {
          programasInscritos: nuevosProgramas.map((p) => p.nombre),
        };

        const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Error al guardar los programas");
        toast.success("Programa añadido correctamente");
      } catch (error) {
        console.error("Error al guardar programas:", error);
        toast.error("No se pudo guardar el programa");
      }
    }
  };

  /* Eliminar programa */
  const handleDeletePrograma = async (index) => {
    const nuevosProgramas = programas.filter((_, i) => i !== index);
    setProgramas(nuevosProgramas);

    try {
      const body = {
        programasInscritos: nuevosProgramas.map((p) => p.nombre),
      };

      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al eliminar programa");
      toast.success("Programa eliminado correctamente");
    } catch (error) {
      console.error("Error al eliminar programa:", error);
      toast.error("No se pudo eliminar el programa");
    }
  };

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return "-";
    const fecha = new Date(fechaISO);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  };

  return (
    <div className="habilidades caja-verde">
      <h2 className="blanco fondo-verde mayusculas">PROGRAMAS inscritos</h2>
      <ul className="contenido">
        {[...programas]
          .sort((a, b) => {
            const hoy = new Date();
            const fechaFinA = new Date(a.fechaFin);
            const fechaFinB = new Date(b.fechaFin);

            const haFinalizadoA = a.fechaFin && fechaFinA < hoy;
            const haFinalizadoB = b.fechaFin && fechaFinB < hoy;

            if (!haFinalizadoA && haFinalizadoB) return -1;
            if (haFinalizadoA && !haFinalizadoB) return 1;

            const fechaInicioA = new Date(a.fechaInicio);
            const fechaInicioB = new Date(b.fechaInicio);
            return fechaInicioA - fechaInicioB;
          })
          .map((programa, index) => (
            <li key={index} className="habilidad-item">
              <div className="editar-cv between">
                <div>
                  <strong>{programa.nombre}</strong>
                  <br />
                  <span className="texto-sm">
                    Inicio: {formatearFecha(programa.fechaInicio)}
                  </span>
                  <br />
                  <span className="texto-sm">
                    Fin: {formatearFecha(programa.fechaFin)}
                  </span>
                </div>
                <div className="botones-guardar-cancelar">
                  <button
                    aria-label="Eliminar este programa"
                    className="fondo-blanco eliminar"
                    onClick={() => handleDeletePrograma(index)}
                  >
                    <FaRegTrashCan />
                  </button>
                </div>
              </div>
            </li>
          ))}
      </ul>

      {/* Añadir nuevo programa */}
      <div className="nueva-edicion-rapida flex gap-10 w-100">
        <select
          aria-label="Programas disponibles"
          value={selectedPrograma}
          onChange={(e) => setSelectedPrograma(e.target.value)}
        >
          <option value="" disabled>
            Selecciona un programa
          </option>
          {programasDisponibles
            .filter((op) => !programas.some((p) => p.nombre === op.nombre))
            .map((opcion) => (
              <option key={opcion._id} value={opcion.nombre}>
                {opcion.nombre}
              </option>
            ))}
        </select>
        <button className="boton estrecho" onClick={handleAddPrograma}>
          Añadir
        </button>
      </div>
    </div>
  );
};

export default Programas;
